export default "__VITE_PUBLIC_ASSET__91cb8da5__"